import { GLTFExporter } from 'three/addons/exporters/GLTFExporter.js'

export default function useDownload() {
  function downloadFile(value: Blob, name: string) {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(value)
    link.download = name
    link.click()
  }

  function download3dModel(name: string) {
    const world = useWorld()
    const gltfExporter = new GLTFExporter()

    const options = {
      binary: true,
    }

    gltfExporter.parse(
      world.chairModel,
      function (result) {
        if (result instanceof ArrayBuffer) {
          downloadFile(
            new Blob([result], { type: 'application/octet-stream' }),
            name + '.glb'
          )
        }
      },
      function (error) {
        console.error('An error happened during parsing', error)
      },
      options
    )
  }

  return {
    download3dModel,
  }
}
